import * as React from "react";
import { ReactElement, useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Heading,
  Text,
  Image,
  Button,
  useColorModeValue,
  Container,
  useToast,
  Flex,
  SimpleGrid,
  StackDivider,
  Icon,
  SpaceProps,
  HStack,
  Tag,
  Link,
  Center,
  Grid,
  GridItem,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Skeleton
} from "@chakra-ui/react";
import { PageSlideFade } from "../components/page-transitions";
import { apiHost, baseUrl } from "utils/Cons/Constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import headerBg from "../assets/images/header-background.jpg";
import footerBg from "../assets/images/footer-background.jpg";
import cloudsBg from "../assets/images/cloud-background.png";
import parser from "html-react-parser";
import { MotionBox } from "../components/motion";
import MediaBlock from "../components/media-block";
import FavoritesBlock from "../components/favorites-block";
import ImageBlock from "../components/image-block";
import CrowdBlock from "../components/crowd-block";
import MapBlock from "components/map-block";
import CTABlock from "components/cta-block";
import ImagesBlock from "components/images-block";
import ImagesGridBlock from "components/images-grid-block";
import TabsBlock from "components/tabs-block";
import SlidesBlock from "components/slides-block";
import HighlightsBlock from "components/highlights-block";
import EmbedBlock from "components/embed-block";
import ContentBlock from "components/content-block";
import BookBlock from "components/book-block";
import Slider from "react-slick";
import FpAdBlock from "components/fp-ad-block";
import FcAdBlock from "components/fc-ad-block";
import FeaturedAdBlock from "components/featured-ad-block";
import ShareModal from "components/share-modal";

interface PageType {
  id: number;
  title: string;
  slug: string;
  meta_description?: string;
  header_image_url?: string;
  content_rendered?: string;
  entry?: {
    slides?: any[];
  };
  fields: {
    content_blocks?: any[];
  };
  number_id?: string;
}

const markdownTheme = {
  p: props => {
    const { children } = props;
    return (
      <Text mb={2} fontSize={'0.8em'}>
        {children}
      </Text>
    );
  },
};

const Page = ({ match }) => {
  const toast = useToast();

  const [page, setPage] = useState<PageType>({} as PageType);
  const [loading, setLoading] = useState(true);

  const settingsSlick = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 8000,
  };

  let path = match.params[0].replaceAll('/', '|');

  const getPage = () => {
    let data = {} as PageType;
    axios.get(`${apiHost}/page/get/${path}`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          data.number_id = data.id.toString();
          setPage(data);
          console.log('entry-id', data.id.toString());
          console.log('entry-slug', data.slug);
        }
        setLoading(false);

        return res;
      })
      .catch(err => {
        setLoading(false);
      });

    return data;
  };

  const showToast = (message, status) => {
    toast({
      position: "bottom",
      description: message,
      status: status,
      duration: 5000,
      isClosable: true
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getPage();
  }, []);

  return (
    <PageSlideFade>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.meta_description} />
      </Helmet>
      {loading && (
        <Container maxW={'5xl'} pt={10} pb={10}>
          <Box>
            <Skeleton height="750px" />
          </Box>
        </Container>
      )}
      {!loading && !page.slug && (
        <Box>
          <Container maxW={'5xl'}>
            <Heading
              as={'h3'}
              fontFamily="american"
              fontWeight={600}
              fontSize={{ base: '2xl', sm: '3xl', md: '4xl' }}
              lineHeight={'100%'}
              textAlign="left"
              mt={{ base: 10, md: 5 }}>
              404 Page Not Found
            </Heading>
            <Box textAlign="left">
              <Button as={Link} href="/">Go to Home Page</Button>
            </Box>
          </Container>
        </Box>
      )}
      {page.slug && (
        <Box mt={'11px'}>
          {page.header_image_url ? (
            <Box className="home-header-container" backgroundImage={`url(${page.header_image_url})`} backgroundPosition="center center" backgroundSize="cover" minHeight="70vh">
              <Container maxW={'5xl'}>
                <Stack
                  textAlign={'center'}
                  align={'center'}
                  spacing={{ base: 8, md: 10 }}
                  py={{ base: 20, md: 28 }}>
                  <MotionBox
                    w="100%"
                    opacity="0"
                    initial={{
                      translateY: 180
                    }}
                    animate={{
                      translateY: 0,
                      opacity: 1,
                      transition: {
                        delay: 0.4,
                        duration: 0.5
                      }
                    }}
                  >
                    <Heading
                      as={'h1'}
                      fontFamily="american"
                      fontWeight={600}
                      fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                      color="white"
                      lineHeight={'100%'}
                      textShadow="2px 2px 8px rgba(0,0,0,0.5)"
                      mt={{ base: 20, md: 0 }}>
                      {page.title} in {' '}
                      <Text as={'div'} fontFamily="brush" fontWeight={500}
                        fontSize={{ base: '6rem', md: '13rem' }} color="white" textShadow="2px 2px 8px rgba(0,0,0,0.5)" mt="6rem">
                        Bellefonte
                      </Text>
                    </Heading>
                  </MotionBox>
                </Stack>

              </Container>
            </Box>
          ) : null}
          {page.entry.slides ? (
            <Slider {...settingsSlick} className="page-slider">
              {page.entry.slides?.map((slide, index) => (
                <div>
                  {slide.img != null && (
                    <Link href={slide.link}>
                      <Box className="home-header-container" backgroundImage={`url(${slide.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="70vh">
                        <Container maxW={'5xl'}>
                          <Stack
                            textAlign={'center'}
                            align={'center'}
                            spacing={{ base: 8, md: 10 }}
                            py={{ base: 20, md: 28 }}>
                            <MotionBox
                              w="100%"
                              opacity="0"
                              initial={{
                                translateY: 180
                              }}
                              animate={{
                                translateY: 0,
                                opacity: 1,
                                transition: {
                                  delay: 0.4,
                                  duration: 0.5
                                }
                              }}
                            >
                              <Heading
                                as={'h1'}
                                fontFamily="american"
                                fontWeight={600}
                                fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                                color="white"
                                lineHeight={'100%'}
                                mt={{ base: 20, md: 0 }}>
                                {page.title} in {' '}
                                <Text as={'div'} fontFamily="brush" fontWeight={500}
                                  fontSize={{ base: '6rem', md: '13rem' }} color="white" textShadow="2px 2px 8px rgba(0,0,0,0.5)" mt="6rem">
                                  Bellefonte
                                </Text>
                              </Heading>
                            </MotionBox>
                          </Stack>

                        </Container>
                      </Box>
                    </Link>
                  )}
                </div>
              ))}
            </Slider>
          ) : null}
          <Box bg="#143b49">
            <Container maxW={'5xl'}>
              <SimpleGrid columns={1}>
                <Box>
                  <Text
                    as="h1"
                    textAlign="left"
                    fontFamily="american"
                    fontWeight={600}
                    fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
                    lineHeight={'120%'}
                    color="#fbeec8"
                    mt={{ base: 4, md: 0 }}
                  >{page.title}</Text>
                </Box>
              </SimpleGrid>
            </Container>
          </Box>
          <Box bg="#FBEEC8">
            <Container maxW={'5xl'} pb={10}>
              <Box className="content-block" textAlign="left" bg="white" p={10} roundedBottomRight={20}>
                {page.content_rendered != null ? (
                  <Text textAlign="left">
                    {parser(page.content_rendered)}
                  </Text>
                ) : null}
                <SimpleGrid columns={3} mt={10}>
                  <Box></Box>
                  <Box></Box>
                  <Box>
                    <ShareModal page={page} />
                  </Box>
                </SimpleGrid>
              </Box>

            </Container>

            {page.fields.content_blocks?.map((block, index) => (
              <Box key={`block-${index}`}>
                {
                  {
                    'anomaly.extension.favorites_block_block': <FavoritesBlock page={page} block={block} />,
                    'anomaly.extension.media_block_block': <MediaBlock page={page} block={block} />,
                    'anomaly.extension.image_block_block': <ImageBlock page={page} block={block} />,
                    'anomaly.extension.crowd_block_block': <CrowdBlock page={page} block={block} />,
                    'anomaly.extension.map_block_block': <MapBlock page={page} block={block} />,
                    'anomaly.extension.cta_block_block': <CTABlock page={page} block={block} />,
                    'anomaly.extension.images_block_block': <ImagesBlock page={page} block={block} />,
                    'anomaly.extension.images_grid_block_block': <ImagesGridBlock page={page} block={block} />,
                    'anomaly.extension.tabs_block_block': <TabsBlock page={page} block={block} />,
                    'anomaly.extension.slides_block_block': <SlidesBlock page={page} block={block} />,
                    'anomaly.extension.highlights_block_block': <HighlightsBlock page={page} block={block} />,
                    'anomaly.extension.embed_block_block': <EmbedBlock page={page} block={block} />,
                    'anomaly.extension.content_block_block': <ContentBlock page={page} block={block} />,
                    'anomaly.extension.book_block_block': <BookBlock page={page} block={block} />,
                    'anomaly.extension.fp_ad_block_block': <FpAdBlock page={page} block={block} />,
                    'anomaly.extension.fc_ad_block_block': <FcAdBlock page={page} block={block} />,
                    'anomaly.extension.featured_ad_block_block': <FeaturedAdBlock page={page} block={block} />,
                  }[block.extension]
                }
              </Box>
            ))}

            <FeaturedAdBlock page={page} block={null} />

          </Box>
        </Box>
      )}

    </PageSlideFade >
  );
};

export default Page;
